import { Flame, Coffee, Brain } from "lucide-react";

const OPTIONS = [
  { value: "hype", label: "Hype", icon: Flame },
  { value: "chill", label: "Chill", icon: Coffee },
  { value: "trivia", label: "Trivia", icon: Brain },
];

export default function PersonalityPicker({ value, onChange }) {
  return (
    <div data-testid="personality-picker" className="flex items-center gap-1 bg-[#0F1636] border border-white/10 rounded-full p-1">
      {OPTIONS.map((o) => {
        const Icon = o.icon;
        const active = value === o.value;
        return (
          <button
            key={o.value}
            data-testid={`personality-${o.value}`}
            data-active={active}
            aria-pressed={active}
            onClick={() => onChange(o.value)}
            title={`${o.label} host`}
            className={`flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 transition-colors ${
              active ? "bg-[#00D9FF] text-navy-ink" : "text-[#A0A0AB] hover:text-white hover:bg-white/5"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden md:inline">{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
